const getServerLocation = () => {
  const serverLocation = process.env.REACT_APP_API_URL
  return serverLocation;
};

const getMediaLocation = () => {
  const mediaLocation = process.env.REACT_APP_MEDIA_URL
  return mediaLocation;
};

const getWebsocketServerLocation = () => {
  const serverLocation = process.env.REACT_APP_WS_URL
  return serverLocation;
};

// CDN serverless (CloudFront): sirve static/ y dynamic/ desde S3.
const getCdnLocation = () => {
  return process.env.REACT_APP_CDN_URL;
};

export const cityIOSettings = {
  apiURL: getServerLocation(),
  mediaURL: getMediaLocation(),
  websocketURL: getWebsocketServerLocation(),
  cdnURL: getCdnLocation(),
  // Íconos de pines: empaquetados con el front (public/icons/), servidos por Amplify.
  iconsURL: `${process.env.PUBLIC_URL || ""}/icons`,
};

// MAYBE USEFUL LATER
// export const mapSettings = {
//   map: {
//     mapboxLink: "mapbox://styles/relnox/",
//     mapboxRefreshString: "?fresh=true",
//     mapStyles: {
//       Dark: "ck0h5xn701bpr1dqs3he2lecq",
//       Inverse: "cjlu6w5sc1dy12rmn4kl2zljn",
//       Normal: "cl8dv36nv000t14qik9yg4ys6",
//     }
//   },
// };